export default __webpack_public_path__ + "static/media/na.61a06038.svg";